
export const sFechaPublicacion = '2026-05-25T13:52:59.5692998-06:00';
export const sVersion = 'vf1.1.605251352';
            